import { ReactComponent as InstaIcon } from "../../img/icon/instagram.svg";
import { ReactComponent as MailIcon } from "../../img/icon/envelop.svg";
import { ReactComponent as GlobeIcon } from "../../img/icon/link.svg";
import { ReactComponent as FacebookIcon } from "../../img/icon/facebook.svg";

import "../../utilities.css";
import "./ProfileBasicInfo.css";

/**
 * Profile Left is a component in profile displaying personal detail
 * of a user.
 *
 * Proptypes
 * @param userObj for user object
 * @param thisYear for the current committee tenure year
 */

import { currentRole } from "../../utilities.js";

import default_img_src from "../../img/logo/wcr_official_logo.png";

const ProfileBasicInfo = ( {userObj, thisYear} ) => {
  return (
        <div>
            {userObj.profilePicture ? <div style={
              {backgroundImage: `url(${userObj.profilePicture.url})`}} 
              className="u-image u-aspect-43" 
              title={userObj.profilePicture.alternativeText}> </div> : <div style={
                {backgroundImage: `url(${default_img_src})`, backgroundColor: "white"}} 
                className="u-image u-aspect-43" 
                title="Univ logo"> </div>}
            
            <div className="profilebasicinfo-basic">
              <p> 
                Current Role
                <br/>
                <b>
                  {
                    // Check utilities.js on how the current role is figured out.
                    currentRole(userObj, thisYear)
                  }
                </b> 
              </p>
              <p> 
                Subject
                <br/>
                <b>{userObj.subject}</b> 
              </p>
              <p>
                Joined Univ since
                <br/>
                <b>{userObj.joinedUnivSince}</b>
              </p>
              <p>
                {userObj.email && <a href={`mailto:${userObj.email}`}><MailIcon /></a>}
                {userObj.univIntro && (<a href={userObj.univIntro}><img src={default_img_src} style={{width: 32, margin: 0, padding: 0}} alt="martlet"/></a>)}
                {userObj.website && (<a href={userObj.website}><GlobeIcon /></a>)}
              </p>
            </div>
        </div>
    );
  }

export default ProfileBasicInfo;